import { useState } from "react";
import {
  ACTIVATE_RULE_ENGINE_GQL,
  REMOVE_RULE_ENGINE_GQL,
} from "../../Apollo/AdminServices/MailRuleReportRequest";
import graphHandler from "../../Apollo/graphHandler";
function useRuleEngineAPI() {
  const [loading, setLoading] = useState(false);
  const activateRule = async (req = {}, callback = () => {}) => {
    setLoading(true);
    try {
      await graphHandler().invoke(
        ACTIVATE_RULE_ENGINE_GQL,
        req,
        1,
        false,
        true
      );
      callback();
      setLoading(false);
    } catch (error) {
      console.log("activateRule Error", error);
      setLoading(false);
    }
  };

  const removeRule = async (
    req = {},
    callback = () => {},
    eCallBack = () => {}
  ) => {
    setLoading(true);
    try {
      await graphHandler().invoke(REMOVE_RULE_ENGINE_GQL, req, 1, false, true);
      callback();
      setLoading(false);
    } catch (error) {
      eCallBack(error);
      console.log("removeRule Error", error);
      setLoading(false);
    }
  };

  return {
    loading,
    activateRule,
    removeRule,
  };
}
export default useRuleEngineAPI;
